import { z } from "zod";

/**
 * Create Campaign Form Validation Schema
 * ------------------------------------------------------------
 * All fields are required.
 *
 * Fields:
 * - campaignName
 * - description
 * - campaignAccessType
 * - inviteDomains
 * - joinCode
 */
export const createCampaignSchema = z
  .object({
    campaignName: z.string().trim().min(1, "Campaign name is required"),

    description: z.string().trim().min(1, "Description is required"),

    campaignAccessType: z
      .string()
      .trim()
      .min(1, "Campaign access type is required"),

    //   allowedDomains: z
    //     .array(z.string().trim().min(1, "Domain is required"))
    //     .min(1, "At least one domain is required"),

    //     invitedEmails: z
    //     .array(z.string().email("Invalid email address"))
    //     .min(1, "At least one email is required"),

    //   // joinCode: z.string().trim().min(1, "Join code is required"),
    // });
    allowedDomains: z
      .array(
        z
          .string()
          .trim()
          .toLowerCase()
          .refine(
            (value) => {
              // reject emails
              if (value.includes("@")) return false;

              // valid domain only
              return /^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/.test(value);
            },
            {
              message:
                "Only valid domain names are allowed",
            },
          ),
      )
      .min(1, "At least one domain is required"),

    invitedEmails: z.array(
      z.string().trim().toLowerCase().email("Invalid email address"),
    ) .optional()
  .default([]),
  })
  // .superRefine((data, ctx) => {
  //   const { invitedEmails, allowedDomains, campaignAccessType } = data;

  //   // validation only for invite only
  //   if (campaignAccessType !== "INVITE_ONLY") return;

  //   // empty emails validation
  //   if (invitedEmails.length === 0) {
  //     ctx.addIssue({
  //       code: z.ZodIssueCode.custom,
  //       path: ["invitedEmails", 0],
  //       message: "At least one email is required",
  //     });

  //     return;
  //   }

  //   invitedEmails.forEach((email, index) => {
  //     const emailDomain = email.split("@")[1];

  //     const isAllowed = allowedDomains.includes(emailDomain);

  //     if (!isAllowed) {
  //       ctx.addIssue({
  //         code: z.ZodIssueCode.custom,
  //         path: ["invitedEmails", index],
  //         message: `Email must belong to: ${allowedDomains.join(", ")}`,
  //       });
  //     }
  //   });
  // });
